import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumUkDutyRate implements BaseEnumType {
  private static allValues: EnumUkDutyRate[] = []; // make sure this is top-most
  
  public static none = new EnumUkDutyRate(0, "None", "enum_uk_duty_rate_none");
  public static beer = new EnumUkDutyRate(1, "Beer", "enum_uk_duty_rate_beer");
  public static lowStrengthBeer = new EnumUkDutyRate(2, "LowStrengthBeer", "enum_uk_duty_rate_low_strength_beer");
  public static highStrengthBeer = new EnumUkDutyRate(3, "HighStrengthBeer", "enum_uk_duty_rate_high_strength_beer");
  public static stillCiderPerry = new EnumUkDutyRate(4, "StillCiderPerry", "enum_uk_duty_rate_still_cider_perry");
  public static sparklingCiderPerry = new EnumUkDutyRate(5, "SparklingCiderPerry", "enum_uk_duty_rate_sparkling_cider_perry");
  public static stillWine = new EnumUkDutyRate(6, "StillWine", "enum_uk_duty_rate_still_wine");
  public static sparklingWine = new EnumUkDutyRate(7, "SparklingWine", "enum_uk_duty_rate_sparkling_wine");
  public static spirits = new EnumUkDutyRate(8, "Spirits", "enum_uk_duty_rate_spirits");
  public static wineAsSpirit = new EnumUkDutyRate(9, "WineAsSpirit", "enum_uk_duty_rate_wine_as_spirit");
  public static scotchWhisky = new EnumUkDutyRate(10, "ScotchWhisky", "enum_uk_duty_rate_scotch_whisky");
  public static irishWhiskey = new EnumUkDutyRate(11, "IrishWhiskey", "enum_uk_duty_rate_irish_whiskey");
  public static generalPerL = new EnumUkDutyRate(12, "GeneralPerL", "enum_uk_duty_rate_general_per_l");
  public static generalPerLaa = new EnumUkDutyRate(13, "GeneralPerLaa", "enum_uk_duty_rate_general_per_laa");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumUkDutyRate.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumUkDutyRate.none; }
  public isBeer() { return this === EnumUkDutyRate.beer; }
  public isLowStrengthBeer() { return this === EnumUkDutyRate.lowStrengthBeer; }
  public isHighStrengthBeer() { return this === EnumUkDutyRate.highStrengthBeer; }
  public isStillCiderPerry() { return this === EnumUkDutyRate.stillCiderPerry; }
  public isSparklingCiderPerry() { return this === EnumUkDutyRate.sparklingCiderPerry; }
  public isStillWine() { return this === EnumUkDutyRate.stillWine; }
  public isSparklingWine() { return this === EnumUkDutyRate.sparklingWine; }
  public isSpirits() { return this === EnumUkDutyRate.spirits; }
  public isWineAsSpirit() { return this === EnumUkDutyRate.wineAsSpirit; }
  public isScotchWhisky() { return this === EnumUkDutyRate.scotchWhisky; }
  public isIrishWhiskey() { return this === EnumUkDutyRate.irishWhiskey; }
  public isGeneralPerL() { return this === EnumUkDutyRate.generalPerL; }
  public isGeneralPerLaa() { return this === EnumUkDutyRate.generalPerLaa; }

  public static getValues(): readonly EnumUkDutyRate[] {
    return EnumUkDutyRate.allValues;
  }

  public static getValuesExcept0(): readonly EnumUkDutyRate[] {
    return EnumUkDutyRate.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumUkDutyRate {
    const found = EnumUkDutyRate.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumUkDutyRate - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumUkDutyRate): EnumUkDutyRate {
    const found = name ? EnumUkDutyRate.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumUkDutyRate - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumUkDutyRate>): boolean {
    return this.key === other?.key;
  }
}